/**
 * Чи помилка запиту означає, що сервер недоступний (мережа — статус 0, збій сервера — 5xx), а не відповідь сервера про сам запит (4xx).
 * Лише тоді сторінки модуля працюють на визначенні з файлів пакета: інакше вони показали б опубліковане визначення замість налаштованого
 * простором (ADR-023). Чиста функція.
 */
export function isOfflineError(error: unknown): boolean {
  if (!error || typeof error !== 'object' || !('status' in error)) return !!error;
  const status = (error as { status: unknown }).status;
  return typeof status !== 'number' || status === 0 || status >= 500;
}
